/* eslint-disable no-param-reassign */
import { createActionTypeReducer } from 'util/reducers'
import {
  FETCH_CANNED_REPLY_TEMPLATE_STARTED,
  FETCH_CANNED_REPLY_TEMPLATE_SUCCESS,
  FETCH_CANNED_REPLY_TEMPLATE_FAILED,
} from '../types'

export const defaultState = {
  isLoading: false,
  isLoaded: false,
  hasError: false,
}

export default createActionTypeReducer(
  {
    [FETCH_CANNED_REPLY_TEMPLATE_STARTED]: draftState => {
      draftState.isLoading = true
      return draftState
    },
    [FETCH_CANNED_REPLY_TEMPLATE_SUCCESS]: draftState => {
      draftState.isLoading = false
      draftState.isLoaded = true
      draftState.hasError = false
      return draftState
    },
    [FETCH_CANNED_REPLY_TEMPLATE_FAILED]: draftState => {
      draftState.isLoading = false
      draftState.hasError = true
      return draftState
    },
  },
  defaultState
)
